import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
    createAboutSection,
    deleteAboutSection,
    getAdminAboutSections,
    updateAboutSection
} from '../api';
import AboutForm from '../components/AboutForm';
import AboutList from '../components/AboutList';

const AdminAboutPage = () => {
  const { slug } = useParams();
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editSection, setEditSection] = useState(null);
  const [toast, setToast] = useState({ show: false, message: '', type: 'success' });
  const [formLoading, setFormLoading] = useState(false);

  const fetchSections = () => {
    setLoading(true);
    getAdminAboutSections(slug)
      .then(res => setSections(res.data.data || []))
      .catch(() => setSections([]))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (!slug) return;
    fetchSections();
    // eslint-disable-next-line
  }, [slug]);

  const handleCreate = () => {
    setEditSection(null);
    setShowForm(true);
  };

  const handleEdit = (section) => {
    setEditSection(section);
    setShowForm(true);
  };

  const handleDelete = async (section) => {
    if (!window.confirm('Delete this section?')) return;
    try {
      await deleteAboutSection(section.id);
      setToast({ show: true, message: 'Section deleted', type: 'success' });
      fetchSections();
    } catch {
      setToast({ show: true, message: 'Delete failed', type: 'error' });
    }
  };

  const handleFormSubmit = async (data) => {
    setFormLoading(true);
    try {
      if (editSection) {
        await updateAboutSection(editSection.id, data);
        setToast({ show: true, message: 'Section updated', type: 'success' });
      } else {
        await createAboutSection(slug, data);
        setToast({ show: true, message: 'Section created', type: 'success' });
      }
      setShowForm(false);
      fetchSections();
    } catch {
      setToast({ show: true, message: 'Save failed', type: 'error' });
    } finally {
      setFormLoading(false);
    }
  };

  return (
    <div className="p-4 max-w-2xl mx-auto">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-xl font-bold">About Sections</h1>
        <button
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          onClick={handleCreate}
        >
          Add Section
        </button>
      </div>
      <AboutList
        sections={sections}
        onEdit={handleEdit}
        onDelete={handleDelete}
        isLoading={loading}
      />
      {/* Modal for create/edit */}
      {showForm && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
          <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md mx-2">
            <AboutForm
              initialValues={editSection || { title: '', content: '' }}
              onSubmit={handleFormSubmit}
              onCancel={() => setShowForm(false)}
              isLoading={formLoading}
              isEdit={!!editSection}
            />
          </div>
        </div>
      )}
      {/* Toast */}
      {toast.show && (
        <div className={`fixed bottom-24 left-1/2 transform -translate-x-1/2 px-4 py-2 rounded shadow text-white ${toast.type === 'success' ? 'bg-green-600' : 'bg-red-600'}`}
          onClick={() => setToast({ ...toast, show: false })}
        >
          {toast.message}
        </div>
      )}
    </div>
  );
};

export default AdminAboutPage; 